import {
    TweenLite
} from "gsap";

class Slideshow {

    constructor(windowSizes) {
        this.windowSizes = windowSizes;

        this.duration = 1.5
        this.limitHeight = 750

        this.prevBtn = document.querySelector('.section-slideshow__nav__left')
        this.nextBtn = document.querySelector('.section-slideshow__nav__right')
        this.container = document.querySelector('.section-slideshow__inner')
        this.items = Array
            .prototype
            .slice
            .call(this.container.querySelectorAll('.section-slideshow__inner__item'))
        this.activeId = 0
        this.activeItem = this.items[0]
        this.numItems = this.items.length
        this.navBlocked = false
        this.navContainer = document.querySelector('.section-slideshow__pagination__numbers__inner')
    }

    init() {
        this
            .prevBtn
            .addEventListener('click', () => {
                this.onPrev()
            })
        this
            .nextBtn
            .addEventListener('click', () => {
                this.onNext()
            })

        this.initPositions()
    }

    initPositions() {
        this.hideOtherItems()
        this.assignStyle(this.activeItem, this.getActiveStyle())
        this.initNextPos()
        this.resizeContainer()
    }

    onPrev() {
        if (this.navBlocked)
            return

        this.blockNav()

        this.activeId = (this.activeId - 1 >= 0) ?
            this.activeId - 1 :
            this.numItems - 1

        this.animateNav()

        const prevItem = (this.activeId - 1 < 0) ?
            this.getItem(this.numItems - 1) :
            this.getItem(this.activeId - 1)

        const nextItem = (this.activeId + 1 < this.numItems) ?
            this.getItem(this.activeId + 1) :
            this.getItem(0)

        this.moveItem('prev', prevItem, nextItem);
    }

    onNext() {
        if (this.navBlocked)
            return

        this.blockNav()

        this.activeId = (this.activeId + 1 < this.numItems) ?
            this.activeId + 1 :
            0;

        this.animateNav()

        // Move main item to out
        const prevItem = (this.activeId - 1 < 0) ?
            this.getItem(this.numItems - 1) :
            this.getItem(this.activeId - 1)

        const nextItem = (this.activeId + 1 < this.numItems) ?
            this.getItem(this.activeId + 1) :
            this.getItem(0)
        this.moveItem('next', prevItem, nextItem);
    }

    animateNav() {
        TweenLite.to(this.navContainer, this.duration, {
            y: -this.activeId * 50,
            ease: Quint.easeInOut
        })
    }

    blockNav() {
        this.navBlocked = true
        setTimeout(() => {

            this.navBlocked = false
        }, this.duration * 1000)
    }

    moveItem(dir, prevItem, nextItem) {

        // New active item
        this.activeItem = this.getItem(this.activeId)

        switch (dir) {
            case 'next':
                this.animateNewActive();
                this.animateLeft();
                this.showNextLeft(nextItem);
                this.hidePrevActive(prevItem)
                break;
            case 'prev':
                this.animateNewPrevActive();
                this.animatePrevToLeft(nextItem);
                break;
        }

    }

    hidePrevActive(prevItem) {
        setTimeout(() => {

            this.assignStyle(prevItem, {
                zIndex: -1
            })
        }, this.duration * 1000)
    }

    animateMask(div, fromX, toX) {
        TweenLite.fromTo(div, this.duration, {
            attr: {
                x: fromX
            }
        }, {
            attr: {
                x: toX
            },
            ease: Quint.easeInOut
        })
    }

    animateScale(img, fromScale, toScale) {
        TweenLite.fromTo(img, this.duration, {
            scale: fromScale,
            transformOrigin: '50% 50%'
        }, {
            scale: toScale,
            ease: Quint.easeInOut
        })
    }

    animateNewActive() {

        // Clone to new active
        const newCloneActive = this
            .activeItem
            .cloneNode(true)

        this.assignStyle(this.activeItem, {
            zIndex: 1
        })

        // Set style as active top right
        this.assignStyle(newCloneActive, this.getActiveStyle())

        const els = this.getItemMask(newCloneActive)

        // Set new mask style
        this.setMaskStyle(els.divClipPath, els.divImage, els.divBack, 1)

        // Append the clone
        this
            .container
            .appendChild(newCloneActive)

        // Animate the mask
        this.animateMask(els.newActiveMask, -500, 0)
        this.animateScale(els.divImage, 1.3, 1)
        this.animateScale(els.divBack, 1.3, 1)

        setTimeout(() => {
            this
                .activeItem
                .remove()
        }, this.duration * 1000)
    }

    animateLeft() {

        const els = this.getItemMask(this.activeItem)

        // Set new mask style
        this.setMaskStyle(els.divClipPath, els.divImage, els.divBack, .2)

        // Animate the mask
        this.animateMask(els.newActiveMask, 0, 500)
    }

    animateNewPrevActive() {

        this.assignStyle(this.activeItem, this.getActiveStyle())

        const els = this.getItemMask(this.activeItem)

        // Set new mask style
        this.setMaskStyle(els.divClipPath, els.divImage, els.divBack, 1)

        // Animate the mask
        this.animateMask(els.newActiveMask, 500, 0)
        this.animateScale(els.divImage, 1.3, 1)
        this.animateScale(els.divBack, 1.3, 1)
    }

    animatePrevToLeft(item) {

        // Clone
        const newClone = item.cloneNode(true)

        this.assignStyle(item, {
            zIndex: 1
        })
        this.assignStyle(newClone, this.getNextStyle())

        const els = this.getItemMask(newClone)

        // Set new mask style
        this.setMaskStyle(els.divClipPath, els.divImage, els.divBack, .2)

        // Append the clone
        this
            .container
            .appendChild(newClone)

        // Animate the mask
        this.animateMask(els.newActiveMask, 500, 0)
        this.animateScale(els.divImage, 1.3, 1)
        this.animateScale(els.divBack, 1.3, 1)

        setTimeout(() => {
            item.remove()
        }, this.duration * 1000)
    }

    showNextLeft(item) {

        this.assignStyle(item, this.getNextStyle())

        const els = this.getItemMask(item)

        // Set new mask style
        this.setMaskStyle(els.divClipPath, els.divImage, els.divBack, .2)
        this.animateScale(els.divImage, 1.3, 1)
        this.animateScale(els.divBack, 1.3, 1)
    }

    resizeContainer() {

        this.assignStyle(this.container, {
            marginTop: this.getContainerTop() + 'px',
            height: this.getActiveHeight() + 'px'
        })
    }

    resize(windowSizes) {
        this.windowSizes = windowSizes;
        this.hideOtherItems()

        this.assignStyle(this.getItem(this.activeId), this.getActiveStyle())
        const nextItem = (this.activeId + 1 < this.numItems) ?
            this.getItem(this.activeId + 1) :
            this.getItem(0)
        this.assignStyle(nextItem, this.getNextStyle())
        this.resizeContainer()

    }
    /*
        getActiveTop() {
            if (this.windowSizes.mobile) {
                return 0
            } else if (this.windowSizes.tablet) {
                return 0
            } else {
                const minusHeight = (this.windowSizes.height < this.limitHeight) ?
                    this.getActiveHeight() / 2 :
                    360

                return -(this.windowSizes.height / 2 - minusHeight)
            }

        }*/

    getContainerTop() {
        if (this.windowSizes.mobile) {
            return 80
        } else if (this.windowSizes.tablet) {
            return 100
        } else {
            return -200
        }
    }

    getActiveLeft() {

        if (this.windowSizes.mobile) {
            return 0
        } else if (this.windowSizes.tablet) {
            return 0
        } else {
            const minusLeft = (this.windowSizes.height < this.limitHeight) ?
                this.getActiveWidth() / 4 :
                330
            return this.windowSizes.width / 2 - minusLeft
        }

    }

    getActiveWidth() {

        if (this.windowSizes.mobile) {
            return this.windowSizes.width
        } else if (this.windowSizes.tablet) {
            return this.windowSizes.width
        } else {
            return (this.windowSizes.height < this.limitHeight) ?
                this.windowSizes.width / 1.5 :
                1055
        }
    }

    calculateRatio(width) {

        const aspectRatio = 1055 / 594
        return width / aspectRatio
    }

    getActiveHeight() {
        return this.calculateRatio(this.getActiveWidth())
    }

    getNextTop() {
        if (this.windowSizes.mobile) {
            return this.windowSizes.height / 3
        } else if (this.windowSizes.tablet) {
            return this.windowSizes.height / 2
        } else {
            return this.windowSizes.height / 2 - 100
        }

    }

    getNextLeft() {
        return this.windowSizes.width / 2 - this.getNextWidth()
    }

    getNextWidth() {
        if (this.windowSizes.mobile) {
            return this.windowSizes.width
        } else if (this.windowSizes.tablet) {
            return this.windowSizes.width / 1.7
        } else {
            return 830
        }
    }

    getNextHeight() {

        return this.calculateRatio(this.getNextWidth())

    }

    getNextStyle() {
        return {
            width: this.getNextWidth() + 'px',
            height: this.getNextHeight() + 'px',
            top: this.getNextTop() + 'px',
            left: this.getNextLeft() + 'px',
            zIndex: -1,
            opacity: this.windowSizes.mobile || this.windowSizes.tablet ?
                0 : 1
        }
    }

    getActiveStyle() {
        return {
            width: this.getActiveWidth() + 'px',
            height: this.getActiveHeight() + 'px',
            top: 0 + 'px',
            left: this.getActiveLeft() + 'px',
            zIndex: 2,
            opacity: 1
        }
    }

    setMaskStyle(divClipPath, divImage, divBack, opacity) {
        const newId = Math.floor(Math.random() * 10000)
        divClipPath.setAttribute('id', 'clip-path-' + newId);
        divImage.style.clipPath = 'url(#clip-path-' + newId + ')'
        divImage.style.opacity = opacity
        divBack.style.clipPath = 'url(#clip-path-' + newId + ')'
    }

    getItem(id) {
        return this
            .container
            .querySelector('[data-id="' + id + '"]');
    }

    getItemMask(div) {
        const divClipPath = div.querySelector('.clip-path')
        const divImage = div.querySelector('.img')
        const newActiveMask = div.querySelector('.rectangle')
        const divBack = div.querySelector('.back')
        return {
            divClipPath: divClipPath,
            divImage: divImage,
            newActiveMask: newActiveMask,
            divBack: divBack
        }
    }

    initNextPos() {
        const item = this.getItem(1)
        this.assignStyle(item, this.getNextStyle())
        const els = this.getItemMask(item)
        this.setMaskStyle(els.divClipPath, els.divImage, els.divBack, .2)
    }

    hideOtherItems() {
        this
            .items
            .map((item, index) => {
                //if (index > this.activeId + 1 || index < this.activeId - 1) {
                const newStyle = {
                    width: this.getNextWidth() + 'px',
                    top: this.getNextTop() + 200 + 'px',
                    left: this.getNextLeft() - 200 + 'px',
                    opacity: 0
                }
                this.assignStyle(this.getItem(index), newStyle)
                //}
            })
    }

    assignStyle(item, newStyle) {
        Object.assign(item.style, newStyle)
    }

}

export default Slideshow


// WEBPACK FOOTER //
// ./src/js/components/Slideshow.js